(() => {
  function initialize(root) {
    if (root.dataset.rxInitialized) return;
    root.dataset.rxInitialized = 'true';
    const methods = [...root.querySelectorAll('[data-rx-method]')];
    const formats = [...root.querySelectorAll('[data-pd-format]')];
    const form = root.closest('form');
    const setPanel = (selector, visible) => {
      const panel = root.querySelector(selector);
      panel.hidden = !visible;
      panel.querySelectorAll('input').forEach(input => {
        input.disabled = !visible;
        input.required = visible && input.hasAttribute('data-rx-required');
        if (!visible) input.setCustomValidity('');
      });
    };
    const validateAxes = () => {
      root.querySelectorAll('[data-rx-eye]').forEach(row => {
        const cyl = row.querySelector('[data-rx-cyl]');
        const axis = row.querySelector('[data-rx-axis]');
        const hasCylinder = !cyl.disabled && cyl.value !== '' && Number(cyl.value) !== 0;
        axis.required = hasCylinder;
        axis.setCustomValidity(hasCylinder && axis.value === '' ? 'Enter the Axis from your prescription when CYL is not zero.' : '');
      });
    };
    const update = () => {
      const method = methods.find(input => input.checked)?.value || 'Enter now';
      const manual = method === 'Enter now';
      const dual = formats.find(input => input.checked)?.value === 'Dual PD';
      setPanel('[data-rx-manual]', manual);
      setPanel('[data-rx-upload]', method === 'Upload');
      setPanel('[data-rx-later]', method === 'Send later');
      setPanel('[data-single-pd]', manual && !dual);
      setPanel('[data-dual-pd]', manual && dual);
      validateAxes();
    };
    methods.forEach(input => input.addEventListener('change', update));
    formats.forEach(input => input.addEventListener('change', update));
    root.querySelectorAll('[data-rx-cyl], [data-rx-axis]').forEach(input => input.addEventListener('input', validateAxes));
    form?.addEventListener('submit', event => {
      validateAxes();
      if (!form.reportValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    update();
  }
  const scan = () => document.querySelectorAll('[data-eyewear-rx]').forEach(initialize);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
